import React from 'react';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  Icon,
  Text,
  Stack,
  HStack,
  VStack,
  useColorModeValue,
  Flex,
} from '@chakra-ui/react';
import { FaCheckCircle, FaUsers, FaLightbulb, FaGlobe } from 'react-icons/fa';

const Feature = ({ title, text, icon }) => {
  return (
    <Stack>
      <Flex
        w={16}
        h={16}
        align={'center'}
        justify={'center'}
        color={'white'}
        rounded={'full'}
        bg={'brand.500'}
        mb={1}
      >
        {icon}
      </Flex>
      <Text fontWeight={600}>{title}</Text>
      <Text color={'gray.600'}>{text}</Text>
    </Stack>
  );
};

export default function AboutSection() {
  return (
    <Box p={4} bg={useColorModeValue('white', 'gray.800')} id="about">
      <Container maxW={'7xl'} py={16}>
        <Stack spacing={4} as={Container} maxW={'3xl'} textAlign={'center'}>
          <Heading fontSize={'3xl'}>About Mesh Infrastructure Group</Heading>
          <Text color={'gray.600'} fontSize={'xl'}>
            Leading the future of infrastructure development with innovation, sustainability, and excellence
          </Text>
        </Stack>

        <Stack spacing={10} mt={10}>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
            <Stack>
              <Heading size="md" mb={4}>Our Mission</Heading>
              <Text color={'gray.600'}>
                At Mesh Infrastructure Group, we are committed to revolutionizing infrastructure 
                development through innovative solutions that meet the evolving needs of modern 
                communities. Our mission is to create sustainable, resilient, and intelligent 
                infrastructure systems that enhance quality of life while preserving our environment 
                for future generations.
              </Text>
              <Stack mt={4} spacing={2}>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Sustainable Development Practices</Text>
                </HStack>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Cutting-edge Technology Integration</Text>
                </HStack>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Community-Centered Approach</Text>
                </HStack>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Environmental Responsibility</Text>
                </HStack>
              </Stack>
            </Stack>
            
            <Stack>
              <Heading size="md" mb={4}>Our Vision</Heading>
              <Text color={'gray.600'}>
                We envision a world where infrastructure seamlessly integrates with nature and 
                technology, creating smart cities and communities that are both efficient and 
                sustainable. Through our expertise and partnerships, we strive to be the global 
                leader in infrastructure innovation, setting new standards for excellence in 
                design, implementation, and management.
              </Text>
              <Stack mt={4} spacing={2}>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Global Leadership in Infrastructure</Text>
                </HStack>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Innovation-Driven Solutions</Text>
                </HStack>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Strategic Partnerships</Text>
                </HStack>
                <HStack>
                  <Icon as={FaCheckCircle} color="green.500" />
                  <Text>Excellence in Execution</Text>
                </HStack>
              </Stack>
            </Stack>
          </SimpleGrid>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} mt={10}>
            <Feature
              icon={<Icon as={FaUsers} w={10} h={10} />}
              title={'Expert Team'}
              text={
                'Our diverse team of engineers, architects, and consultants brings decades of combined experience to every project.'
              }
            />
            <Feature
              icon={<Icon as={FaLightbulb} w={10} h={10} />}
              title={'Innovation First'}
              text={
                'We leverage the latest technologies and methodologies to deliver cutting-edge infrastructure solutions.'
              }
            />
            <Feature
              icon={<Icon as={FaGlobe} w={10} h={10} />}
              title={'Global Impact'}
              text={
                'Our projects span continents, bringing world-class infrastructure development to communities worldwide.'
              }
            />
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}